require('./src/assets/styles/_libs.scss');
require('./src/assets/styles/_fonts.scss');
require('./src/assets/styles/main.scss');

exports.shouldUpdateScroll = ({ routerProps }) => {
  return routerProps.location.search ? false : true;
};
